"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPageTitle;
var _settings = _interopRequireDefault(require("@/settings"));
var _lang = _interopRequireDefault(require("@/lang"));
var _store = _interopRequireDefault(require("../store"));
var sysTitle = _settings.default.title || '船舶管理平台';

// export default function getPageTitle(key) {
//   const hasKey = i18n.te(`route.${key}`)
//   if (hasKey) {
//     const pageName = i18n.t(`route.${key}`)
//     return `${pageName} - ${title}`
//   }
//   return `${title}`
// }
function getPageTitle(_ref) {
  var titleCn = _ref.titleCn,
    titleEn = _ref.titleEn,
    title = _ref.title;
  if (!(titleCn && titleEn)) {
    var hasKey = _lang.default.te("route.".concat(title));
    if (hasKey) {
      var pageName = _lang.default.t("route.".concat(title));
      return "".concat(pageName, " - ").concat(sysTitle);
    }
    return "".concat(sysTitle);
  } else {
    if (_store.default.getters.language === 'zh') {
      return titleCn ? "".concat(titleCn, "- ").concat(sysTitle) : "".concat(sysTitle);
    } else {
      return titleEn ? "".concat(titleEn, "- ").concat(sysTitle) : "".concat(sysTitle);
    }
  }
}